var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#32BE90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8314 24.845L10.0178 28.913C9.95783 29.2112 10.0515 29.5193 10.266 29.7339C10.4378 29.9057 10.6696 30.0002 10.9087 30.0002C10.9678 30.0002 11.0278 29.9948 11.0869 29.9821L15.1549 29.1684L10.8314 24.845Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.441 13.6368L19.0902 15.9876L11.8178 23.2601L16.7394 28.1817L26.3627 18.5584L21.441 13.6368Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7324 13.9028L26.0962 10.2666C25.7407 9.91114 25.1662 9.91114 24.8108 10.2666L22.7263 12.351L27.6479 17.2727L29.7324 15.1882C30.0878 14.8328 30.0878 14.2582 29.7324 13.9028Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1f3b22c308759e24889e8688d9fdc916.svg";
export { ForwardRef as ReactComponent };